import { defineAsyncComponent } from 'vue';
export default {
    emits: ["change-page", "change-limit"],
    components: { Pagination: defineAsyncComponent(() => import('@/libraries/pagination/index.vue')), },
    data: () => ({ current_page: 0, }),
    watch: { page(page){ this.current_page = page; }, },
    props: {
        page: { type: Number, default: 1},
        total: { type: Number, default: 0},
        limit: { type: Number, default: 50},
    },
    mounted(){ this.current_page = this.page; },
    computed: {
        haspages(){ return this.total > this.limit; },
        isfirst(){ return this.current_page == 1; },
        islast(){ return this.current_page == this.pages; },
        pages(){ return Math.ceil(this.total / this.limit); },
        hasmore3(){ return this.pages >= 3; },
        hasmore6(){ return this.pages > 6; },

        first3(){ return Array.from({ length: this.hasmore3 ? 3 : this.pages }, (_, i) => i+1); },
        last3(){ return Array.from({ length: this.hasmore6 ? 3 : this.pages-3 }, (_, i) => this.pages - i).reverse(); },
        pages0(){ return this.pages >= 3 ? 3 : this.pages; },
        pages3(){ return this.pages-3; },
        ipages3(){ return this.pages >= 6 ? 3 : this.pages3; },
    },
    methods: {
        previousPage(){
            if (!this.isfirst)
                this.change_page(this.current_page - 1);
        },
        nextPage(){
            this.change_page(this.current_page + 1);
        },
        goOnPage(page){
            if (page > 0 && page <= this.pages)
                this.change_page(page);
        },

        calcLimit(page){ return {offset: this.limit * (page - 1), limit: this.limit}; },
        change_page(page){
            this.current_page = page;
            this.$emit("change-page", page)
            this.$emit("change-limit", this.calcLimit(page));
        },
        reset_pagination(payload){
            delete payload.offset;
            delete payload.limit;
            delete payload.page;
            return 1;
        },
    }
}
